var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filters)?_c('GenericExplorer',{key:_vm.reload,attrs:{"filters":_vm.filters,"views":_vm.available_views(_vm.is_mobile,_vm.views_props),"is_mobile":_vm.is_mobile},on:{"update":_vm.update_filters}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }